function TicketOriginFilter () {
  function filter (value) {
    switch (value) {
      case 'shop':
        return 'Loja virtual'
      case 'app':
        return 'Aplicativo'
      case 'dashboard':
        return 'Sistema'
      default:
        return '-'
    }
  }

  return {
    filter
  }
}

export default TicketOriginFilter
